import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bytesToMbytes',
  standalone: false
})
export class BytesToMbytesPipe implements PipeTransform {

  transform(value: number, args?: any): any {
    let returnValue = (value / 1024 / 1024).toFixed(2);
    return returnValue;
  }

}
